export const tours = [
  {
    id: 1,
    slug: "atlas-mountains-day-trip",
    name: "Atlas Mountains Day Trip",
    category: "day-trips",
    destination: "atlas-mountains",
    duration: "8 hours",
    price: 45,
    priceChild: 25,
    rating: 4.9,
    reviews: 312,
    groupSize: "1–15",
    pickup: "Hotel pickup included",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: true,
    badge: "Best Seller",
    emoji: "⛰️",
    bgColor: "#1e3a1a",
    description: "Escape the medina and discover the breathtaking High Atlas Mountains on this full-day guided tour. Visit traditional Berber villages, walk through lush valleys, and enjoy a home-cooked Berber lunch with a local family.",
    highlights: [
      "Drive through stunning High Atlas mountain scenery",
      "Visit the picturesque Berber village of Asni",
      "Enjoy a traditional Berber lunch at a local home",
      "Optional mule ride through mountain trails",
      "Stop at Cascades d'Imlil waterfall",
    ],
    itinerary: [
      { time: "08:00", desc: "Hotel pickup in Marrakech" },
      { time: "09:30", desc: "Arrive at Asni village, meet local Berber family" },
      { time: "11:00", desc: "Trek through mountain trails to Imlil valley" },
      { time: "13:00", desc: "Traditional Berber lunch at local home" },
      { time: "15:00", desc: "Visit waterfalls and argan oil cooperative" },
      { time: "17:30", desc: "Return drive to Marrakech" },
      { time: "18:30", desc: "Drop off at hotel" },
    ],
    included: ["Hotel pickup & drop-off", "Air-conditioned vehicle", "Licensed English/French guide", "Berber lunch", "Bottled water"],
    excluded: ["Personal expenses", "Tips (optional)", "Optional mule ride (€10)", "Travel insurance"],
    meetingPoint: "Your hotel lobby in Marrakech",
    cancellation: "Free cancellation up to 48 hours before",
  },
  {
    id: 2,
    slug: "agafay-desert-day-trip",
    name: "Agafay Desert Day Trip",
    category: "day-trips",
    destination: "agafay-desert",
    duration: "Full day",
    price: 55,
    priceChild: 30,
    rating: 4.8,
    reviews: 241,
    groupSize: "1–12",
    pickup: "Hotel pickup included",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: true,
    badge: "Popular",
    emoji: "🏜️",
    bgColor: "#3d2a0a",
    description: "Discover the magical stone desert just 40 minutes from Marrakech. The Agafay Desert offers a stunning lunar landscape with Atlas Mountains views — perfect for camel rides, quad biking, and Berber camp experiences.",
    highlights: [
      "Rocky desert landscape with Atlas Mountain backdrop",
      "Traditional Berber camp lunch under the stars",
      "Optional camel ride, quad bike, or buggy",
      "Panoramic views over the desert plateau",
      "Sunset golden hour photography",
    ],
    itinerary: [
      { time: "09:00", desc: "Hotel pickup in Marrakech" },
      { time: "10:00", desc: "Arrive at Agafay desert camp" },
      { time: "10:30", desc: "Optional activities: camel ride, quad, buggy" },
      { time: "13:00", desc: "Traditional Berber lunch at the camp" },
      { time: "15:00", desc: "Free time, photography, relaxation" },
      { time: "17:00", desc: "Sunset views from the plateau" },
      { time: "18:30", desc: "Return to Marrakech hotel" },
    ],
    included: ["Hotel pickup & drop-off", "4x4 vehicle", "Licensed guide", "Berber camp lunch", "Mint tea"],
    excluded: ["Optional activities (camel/quad/buggy)", "Tips", "Travel insurance"],
    meetingPoint: "Your hotel lobby in Marrakech",
    cancellation: "Free cancellation up to 48 hours before",
  },
  {
    id: 3,
    slug: "ouzoud-waterfalls-trip",
    name: "Ouzoud Waterfalls Day Trip",
    category: "day-trips",
    destination: "ouzoud",
    duration: "9 hours",
    price: 40,
    priceChild: 22,
    rating: 4.9,
    reviews: 198,
    groupSize: "1–15",
    pickup: "Hotel pickup included",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: true,
    badge: "Scenic",
    emoji: "💧",
    bgColor: "#0a2d3d",
    description: "Visit Morocco's most spectacular waterfalls — a stunning 110-metre cascade surrounded by lush olive groves and wild Barbary macaques. Swim in natural pools and enjoy a riverside lunch.",
    highlights: [
      "110m high waterfalls — Morocco's most impressive",
      "Wild Barbary macaques roaming freely",
      "Natural swimming pools at the base",
      "Scenic boat ride under the waterfall",
      "Olive grove hiking trails",
    ],
    itinerary: [
      { time: "08:00", desc: "Hotel pickup in Marrakech" },
      { time: "10:30", desc: "Arrive at Ouzoud Waterfalls" },
      { time: "11:00", desc: "Guided hike to viewpoints and pools" },
      { time: "13:00", desc: "Lunch at riverside restaurant" },
      { time: "14:30", desc: "Free time: swimming, boat ride, photography" },
      { time: "16:30", desc: "Depart for Marrakech" },
      { time: "19:00", desc: "Arrival back at hotel" },
    ],
    included: ["Hotel pickup & drop-off", "Air-conditioned vehicle", "Licensed guide", "Entrance fees", "Bottled water"],
    excluded: ["Lunch", "Boat ride (€3)", "Tips", "Swimming gear"],
    meetingPoint: "Your hotel lobby in Marrakech",
    cancellation: "Free cancellation up to 48 hours before",
  },
  {
    id: 4,
    slug: "ait-ben-haddou-kasbah",
    name: "Aït Ben Haddou & Kasbah Telouet",
    category: "day-trips",
    destination: "ait-ben-haddou",
    duration: "Full day",
    price: 65,
    priceChild: 35,
    rating: 4.9,
    reviews: 176,
    groupSize: "1–10",
    pickup: "Hotel pickup included",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: false,
    badge: "UNESCO",
    emoji: "🏰",
    bgColor: "#4a2a10",
    description: "Explore two of Morocco's most iconic historic sites — the UNESCO-listed Aït Ben Haddou ksar and the stunning Kasbah Telouet, ancient seat of the powerful Glaoui dynasty.",
    highlights: [
      "UNESCO World Heritage Site — Aït Ben Haddou",
      "The filming location of Game of Thrones & Gladiator",
      "Kasbah Telouet — grand vizier's palace",
      "Drive through the dramatic Tizi n'Tichka Pass",
      "Traditional Moroccan lunch in a kasbah restaurant",
    ],
    itinerary: [
      { time: "07:30", desc: "Hotel pickup in Marrakech" },
      { time: "10:00", desc: "Arrive at Kasbah Telouet" },
      { time: "11:30", desc: "Continue to Aït Ben Haddou ksar" },
      { time: "13:00", desc: "Lunch at local restaurant" },
      { time: "14:30", desc: "Guided tour of the ksar citadel" },
      { time: "16:30", desc: "Return drive via Tizi n'Tichka" },
      { time: "19:30", desc: "Arrive back in Marrakech" },
    ],
    included: ["Hotel pickup & drop-off", "Vehicle", "Licensed guide", "All entrance fees", "Bottled water"],
    excluded: ["Lunch", "Tips", "Travel insurance"],
    meetingPoint: "Your hotel lobby in Marrakech",
    cancellation: "Free cancellation up to 48 hours before",
  },
  {
    id: 5,
    slug: "essaouira-day-trip",
    name: "Essaouira Day Trip",
    category: "day-trips",
    destination: "essaouira",
    duration: "10 hours",
    price: 45,
    priceChild: 25,
    rating: 4.8,
    reviews: 154,
    groupSize: "1–15",
    pickup: "Hotel pickup included",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: false,
    badge: "Coastal",
    emoji: "🌊",
    bgColor: "#0a1e3d",
    description: "Discover the magical blue-and-white medina of Essaouira, a UNESCO-listed coastal town with Portuguese ramparts, fresh seafood, and legendary winds that attract world-class surfers.",
    highlights: [
      "UNESCO-listed blue-and-white medina",
      "16th-century Portuguese sea ramparts",
      "Famous spice and argan oil market",
      "Fresh grilled fish at the harbour",
      "Beautiful Atlantic Ocean beach",
    ],
    itinerary: [
      { time: "08:00", desc: "Hotel pickup in Marrakech" },
      { time: "10:30", desc: "Arrive in Essaouira medina" },
      { time: "10:45", desc: "Guided walking tour of the old town" },
      { time: "12:30", desc: "Free time for lunch at harbour" },
      { time: "14:00", desc: "Visit the ramparts and beach" },
      { time: "16:00", desc: "Return drive to Marrakech" },
      { time: "18:30", desc: "Arrive back at hotel" },
    ],
    included: ["Hotel pickup & drop-off", "Air-conditioned vehicle", "Licensed guide", "Bottled water"],
    excluded: ["Lunch & drinks", "Tips", "Personal shopping"],
    meetingPoint: "Your hotel lobby in Marrakech",
    cancellation: "Free cancellation up to 48 hours before",
  },
  {
    id: 6,
    slug: "ourika-valley-day-trip",
    name: "Ourika Valley Day Trip",
    category: "day-trips",
    destination: "ourika-valley",
    duration: "7 hours",
    price: 35,
    priceChild: 18,
    rating: 4.7,
    reviews: 132,
    groupSize: "1–15",
    pickup: "Hotel pickup included",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: false,
    badge: "Nature",
    emoji: "🌿",
    bgColor: "#1a3020",
    description: "Explore the lush Ourika Valley, just 30km from Marrakech, where the Atlas Mountains meet a rushing river lined with Berber villages and terraced gardens.",
    highlights: [
      "Lush valley contrasting with the Atlas Mountains",
      "Visit a traditional Berber herbalist",
      "Walk to the Setti Fatma waterfalls",
      "See a working argan oil cooperative",
      "Mint tea with a Berber family",
    ],
    itinerary: [
      { time: "09:00", desc: "Hotel pickup in Marrakech" },
      { time: "10:00", desc: "Arrive in Ourika Valley" },
      { time: "10:30", desc: "Visit Berber herbalist and argan cooperative" },
      { time: "12:00", desc: "Hike to Setti Fatma waterfalls" },
      { time: "13:30", desc: "Lunch at riverside restaurant" },
      { time: "15:30", desc: "Return to Marrakech" },
      { time: "16:30", desc: "Hotel drop-off" },
    ],
    included: ["Hotel pickup & drop-off", "Vehicle", "Licensed guide", "Bottled water"],
    excluded: ["Lunch", "Tips", "Waterfall entrance (€2)"],
    meetingPoint: "Your hotel lobby in Marrakech",
    cancellation: "Free cancellation up to 48 hours before",
  },
  {
    id: 7,
    slug: "marrakech-medina-guided-tour",
    name: "Marrakech Medina Guided Tour",
    category: "city-tours",
    destination: "marrakech",
    duration: "4 hours",
    price: 25,
    priceChild: 12,
    rating: 4.9,
    reviews: 423,
    groupSize: "1–12",
    pickup: "Meeting point in Jemaa el-Fna",
    language: ["English", "French", "Arabic"],
    difficulty: "Easy",
    featured: true,
    badge: "Top Rated",
    emoji: "🕌",
    bgColor: "#2d1a0a",
    description: "Navigate the labyrinthine streets of Marrakech's ancient medina with an expert local guide. Discover hidden riads, bustling souks, historic mosques, and the vibrant Jemaa el-Fna square.",
    highlights: [
      "Iconic Jemaa el-Fna square at its most vibrant",
      "Traditional Moroccan souks — leather, spices, textiles",
      "The stunning Koutoubia Mosque gardens",
      "Secret riad courtyards and fountains",
      "Ben Youssef Madrasa (exterior)",
    ],
    itinerary: [
      { time: "09:00", desc: "Meet at Jemaa el-Fna square" },
      { time: "09:15", desc: "Walking tour through the main souks" },
      { time: "10:30", desc: "Leather tanneries viewpoint" },
      { time: "11:00", desc: "Spice square and herbalist visit" },
      { time: "11:45", desc: "Historic Ben Youssef area" },
      { time: "12:30", desc: "Return to Jemaa el-Fna, tour ends" },
    ],
    included: ["Expert local guide", "Entrance to selected sites", "Tea tasting"],
    excluded: ["Museum entrance fees", "Shopping", "Tips"],
    meetingPoint: "Jemaa el-Fna square, near the Café de France",
    cancellation: "Free cancellation up to 24 hours before",
  },
  {
    id: 8,
    slug: "marrakech-food-tour",
    name: "Marrakech Food Tour",
    category: "city-tours",
    destination: "marrakech",
    duration: "3 hours",
    price: 35,
    priceChild: 18,
    rating: 4.8,
    reviews: 201,
    groupSize: "2–10",
    pickup: "Meeting point in the medina",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: false,
    badge: "Foodie",
    emoji: "🥘",
    bgColor: "#3d1a0a",
    description: "Eat your way through Marrakech's most delicious street food with a passionate local foodie guide. Taste fresh msemen, harira soup, mechoui lamb, fresh-squeezed orange juice, and traditional Moroccan pastries.",
    highlights: [
      "7–10 tastings included in the price",
      "Jemaa el-Fna food stalls at their best",
      "Hidden local eateries tourists never find",
      "Learn about Moroccan spices and ingredients",
      "Taste fresh-squeezed orange juice and mint tea",
    ],
    itinerary: [
      { time: "18:00", desc: "Meet at Jemaa el-Fna" },
      { time: "18:15", desc: "Fresh orange juice at famous juice stalls" },
      { time: "18:30", desc: "Harira soup and msemen flatbread" },
      { time: "19:00", desc: "Mechoui lamb pit at the souks" },
      { time: "19:30", desc: "Spice and pastry tasting" },
      { time: "20:00", desc: "Mint tea and chebakia pastries, tour ends" },
    ],
    included: ["All food tastings (7–10 items)", "Expert food guide", "Mint tea"],
    excluded: ["Additional food & drinks", "Tips"],
    meetingPoint: "Jemaa el-Fna, at the orange juice stalls",
    cancellation: "Free cancellation up to 24 hours before",
  },
  {
    id: 9,
    slug: "marrakech-casablanca-day-trip",
    name: "Marrakech to Casablanca Day Trip",
    category: "day-trips",
    destination: "casablanca",
    duration: "12 hours",
    price: 75,
    priceChild: 40,
    rating: 4.7,
    reviews: 89,
    groupSize: "1–8",
    pickup: "Hotel pickup included",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: false,
    badge: "City Tour",
    emoji: "🏙️",
    bgColor: "#1a1a2d",
    description: "Discover Morocco's economic capital and coastal metropolis on this private day trip from Marrakech. Visit the magnificent Hassan II Mosque, the Corniche, and the art deco quarter.",
    highlights: [
      "Hassan II Mosque — world's largest mosque open to non-Muslims",
      "Art deco architecture of the old French quarter",
      "Corniche seafront promenade",
      "Morocco Mall (optional shopping)",
      "Fresh seafood lunch by the Atlantic",
    ],
    itinerary: [
      { time: "07:00", desc: "Hotel pickup in Marrakech" },
      { time: "10:00", desc: "Arrive in Casablanca" },
      { time: "10:30", desc: "Guided tour of Hassan II Mosque" },
      { time: "13:00", desc: "Seafood lunch at the Corniche" },
      { time: "14:30", desc: "Art deco quarter walking tour" },
      { time: "16:00", desc: "Depart for Marrakech" },
      { time: "19:00", desc: "Hotel drop-off" },
    ],
    included: ["Hotel pickup & drop-off", "Vehicle", "Licensed guide", "Mosque entrance", "Bottled water"],
    excluded: ["Lunch", "Tips", "Personal shopping"],
    meetingPoint: "Your hotel lobby in Marrakech",
    cancellation: "Free cancellation up to 48 hours before",
  },
  {
    id: 10,
    slug: "lake-takerkoust-asni-valley",
    name: "Lake Takerkoust & Asni Valley",
    category: "day-trips",
    destination: "atlas-mountains",
    duration: "8 hours",
    price: 50,
    priceChild: 28,
    rating: 4.8,
    reviews: 112,
    groupSize: "1–12",
    pickup: "Hotel pickup included",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: false,
    badge: "Nature",
    emoji: "🏞️",
    bgColor: "#0a2a1a",
    description: "Discover two of the most beautiful natural sites near Marrakech — the tranquil Lake Takerkoust and the lush Asni Valley nestled in the High Atlas foothills.",
    highlights: [
      "Stunning artificial lake with Atlas Mountain reflections",
      "Optional horseback riding along the lakeshore",
      "Asni weekly Berber market (Saturdays)",
      "Scenic drive through countryside villages",
      "Fresh countryside air and mountain views",
    ],
    itinerary: [
      { time: "09:00", desc: "Hotel pickup" },
      { time: "10:00", desc: "Arrive at Lake Takerkoust" },
      { time: "10:30", desc: "Lakeside walk and optional horseback ride" },
      { time: "12:30", desc: "Drive to Asni Valley" },
      { time: "13:00", desc: "Lunch in Asni village" },
      { time: "14:30", desc: "Explore the valley and Berber village" },
      { time: "16:30", desc: "Return to Marrakech" },
    ],
    included: ["Hotel pickup & drop-off", "Vehicle", "Guide", "Bottled water"],
    excluded: ["Lunch", "Horseback riding", "Tips"],
    meetingPoint: "Your hotel lobby in Marrakech",
    cancellation: "Free cancellation up to 48 hours before",
  },
  {
    id: 11,
    slug: "marrakech-photography-tour",
    name: "Private Marrakech Photography Tour",
    category: "city-tours",
    destination: "marrakech",
    duration: "3 hours",
    price: 60,
    priceChild: 30,
    rating: 4.9,
    reviews: 87,
    groupSize: "1–4",
    pickup: "Meeting point in the medina",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: false,
    badge: "Private",
    emoji: "📸",
    bgColor: "#1a0a2d",
    description: "Capture the most photogenic corners of Marrakech with a local photography guide who knows every hidden angle, best light, and secret rooftop. Perfect for Instagram, professional shoots, and golden hour.",
    highlights: [
      "Hidden rooftop terraces with medina panoramas",
      "Tanneries — the most photogenic spot in Morocco",
      "Vibrant Jemaa el-Fna at golden hour",
      "Colourful souks and doorways",
      "Tips on camera settings for Moroccan light",
    ],
    itinerary: [
      { time: "Golden hour start", desc: "Meet at medina entrance" },
      { time: "+30 min", desc: "Hidden rooftop terrace views" },
      { time: "+1h", desc: "Tanneries photography session" },
      { time: "+1h45", desc: "Souk colours and doorways" },
      { time: "+2h30", desc: "Jemaa el-Fna at golden hour" },
      { time: "+3h", desc: "Tour ends" },
    ],
    included: ["Private photography guide", "All location access"],
    excluded: ["Camera equipment", "Tips"],
    meetingPoint: "Bab Doukkala gate, medina entrance",
    cancellation: "Free cancellation up to 24 hours before",
  },
  {
    id: 12,
    slug: "shopping-in-the-souks",
    name: "Shopping in the Souks",
    category: "city-tours",
    destination: "marrakech",
    duration: "3 hours",
    price: 20,
    priceChild: 0,
    rating: 4.7,
    reviews: 165,
    groupSize: "1–8",
    pickup: "Meeting point in the medina",
    language: ["English", "French", "Arabic"],
    difficulty: "Easy",
    featured: false,
    badge: "Shopping",
    emoji: "🛍️",
    bgColor: "#2d0a1a",
    description: "Navigate Marrakech's famous souks with a local guide who knows how to bargain, which stalls have genuine crafts, and the best spots for leather, spices, textiles, ceramics, and Moroccan lamps.",
    highlights: [
      "Expert bargaining guidance — get the best prices",
      "Leather goods souk — genuine quality explained",
      "Spice square — identify 30+ Moroccan spices",
      "Berber carpet workshop visit",
      "Copper and lantern artisan district",
    ],
    itinerary: [
      { time: "10:00", desc: "Meet at Jemaa el-Fna" },
      { time: "10:15", desc: "Leather souk and tanneries" },
      { time: "11:00", desc: "Spice square — tasting and shopping" },
      { time: "11:30", desc: "Textile and carpet souk" },
      { time: "12:15", desc: "Copper and lantern artisans" },
      { time: "13:00", desc: "Tour ends — free shopping time" },
    ],
    included: ["Local shopping guide", "Bargaining lessons", "Tea at a riad"],
    excluded: ["Purchases", "Tips"],
    meetingPoint: "Jemaa el-Fna, Café de France entrance",
    cancellation: "Free cancellation up to 24 hours before",
  },
  {
    id: 13,
    slug: "marrakech-agadir-day-trip",
    name: "Marrakech to Agadir Day Trip",
    category: "day-trips",
    destination: "agadir",
    duration: "Full day",
    price: 70,
    priceChild: 40,
    rating: 4.8,
    reviews: 98,
    groupSize: "1–15",
    pickup: "Hotel pickup included",
    language: ["English", "French"],
    difficulty: "Easy",
    featured: false,
    badge: "Coastal",
    emoji: "🏖️",
    bgColor: "#0a2040",
    description: "Escape to Morocco's stunning Atlantic coast on this full-day trip from Marrakech to Agadir. Enjoy the beautiful beach, the famous Agadir souk, the historic Kasbah with panoramic ocean views, and fresh seafood by the sea.",
    highlights: [
      "Agadir's beautiful Atlantic beach promenade",
      "Panoramic views from the ancient Agadir Kasbah",
      "Explore the vibrant Agadir souk",
      "Fresh seafood lunch by the ocean",
      "Scenic coastal and mountain road drive",
    ],
    itinerary: [
      { time: "07:00", desc: "Hotel pickup in Marrakech" },
      { time: "10:00", desc: "Arrive in Agadir — visit the Kasbah" },
      { time: "11:30", desc: "Explore the beach promenade" },
      { time: "13:00", desc: "Lunch at a seafood restaurant" },
      { time: "14:30", desc: "Agadir souk shopping" },
      { time: "16:00", desc: "Free beach time or relaxation" },
      { time: "17:00", desc: "Depart for Marrakech" },
      { time: "20:00", desc: "Arrive back in Marrakech" },
    ],
    included: ["Hotel pickup & drop-off", "Air-conditioned vehicle", "Licensed guide", "Bottled water"],
    excluded: ["Lunch", "Personal expenses", "Tips", "Travel insurance"],
    meetingPoint: "Your hotel lobby in Marrakech",
    cancellation: "Free cancellation up to 48 hours before",
  },
];

export const activities = [
  {
    id: 1,
    slug: "hot-air-balloon-marrakech",
    name: "Hot Air Balloon Ride",
    type: "adventure",
    location: "Marrakech",
    duration: "3 hours",
    price: 180,
    priceChild: 140,
    rating: 4.9,
    reviews: 287,
    minAge: 6,
    fitnessLevel: "All levels",
    featured: true,
    emoji: "🎈",
    bgColor: "#1a0a2d",
    badge: "Unmissable",
    description: "Soar above Marrakech and the Atlas Mountains at sunrise in a traditional hot air balloon. Float silently over the ochre city, the Palmeraie palm forest, and the High Atlas peaks as the world wakes up below.",
    highlights: [
      "Sunrise flight over Marrakech and the Atlas Mountains",
      "Flight duration of approximately 1 hour",
      "Traditional Berber breakfast after landing",
      "Certificate of flight",
      "Hotel pickup from Marrakech at 05:30",
    ],
    included: ["Hotel pickup", "Balloon flight", "Berber breakfast", "Certificate", "Return transfer"],
    excluded: ["Tips", "Travel insurance"],
    meetingPoint: "Hotel pickup at 05:30 AM",
  },
  {
    id: 2,
    slug: "camel-ride-palmeraie",
    name: "Camel Ride in the Palmeraie",
    type: "animal",
    location: "Palmeraie",
    duration: "1–2 hours",
    price: 30,
    priceChild: 18,
    rating: 4.7,
    reviews: 432,
    minAge: 4,
    fitnessLevel: "All levels",
    featured: true,
    emoji: "🐪",
    bgColor: "#3d2d0a",
    badge: "Classic",
    description: "Ride a camel through Marrakech's famous Palmeraie palm forest — a 13,000-hectare oasis just minutes from the medina. A quintessential Moroccan experience for all ages.",
    highlights: [
      "Ride through 13,000 hectares of palm forest",
      "Traditional Berber tent tea stop",
      "Perfect for families and all ages",
      "Option for 1-hour or 2-hour rides",
      "Transport from hotel available",
    ],
    included: ["Camel ride", "Guide", "Mint tea at Berber tent"],
    excluded: ["Hotel transport (optional extra)", "Tips"],
    meetingPoint: "Palmeraie entrance, or hotel pickup available",
  },
  {
    id: 3,
    slug: "camel-ride-agafay",
    name: "Camel Ride in Agafay Desert",
    type: "animal",
    location: "Agafay",
    duration: "1 hour",
    price: 35,
    priceChild: 20,
    rating: 4.8,
    reviews: 198,
    minAge: 4,
    fitnessLevel: "All levels",
    featured: false,
    emoji: "🐫",
    bgColor: "#4a3010",
    badge: "Desert",
    description: "Experience the magic of the Agafay stone desert on camelback, with the High Atlas Mountains as your backdrop. A dramatic and unforgettable experience just 40 minutes from Marrakech.",
    highlights: [
      "Dramatic stone desert landscape",
      "Atlas Mountain panoramas",
      "Sunset ride option available",
      "Often combined with Agafay day trip",
      "Berber guide on foot alongside",
    ],
    included: ["Camel ride", "Berber guide", "Mint tea"],
    excluded: ["Transport to Agafay", "Tips"],
    meetingPoint: "Agafay desert camp — transport available from Marrakech",
  },
  {
    id: 4,
    slug: "quad-palmeraie",
    name: "Quad Biking in the Palmeraie",
    type: "adventure",
    location: "Palmeraie",
    duration: "2 hours",
    price: 45,
    priceChild: null,
    rating: 4.7,
    reviews: 312,
    minAge: 16,
    fitnessLevel: "Active",
    featured: true,
    emoji: "🏍️",
    bgColor: "#2d1a0a",
    badge: "Thrill",
    description: "Race through the Palmeraie palm forest on a powerful quad bike. Thrilling tracks through palm groves, sand tracks, and Berber village paths just outside Marrakech.",
    highlights: [
      "Modern quad bikes (automatic, easy to ride)",
      "Palm forest and sand track circuits",
      "No experience necessary — full briefing given",
      "1-hour or 2-hour session options",
      "Safety equipment provided",
    ],
    included: ["Quad bike", "Safety helmet & goggles", "Full briefing", "Guide"],
    excluded: ["Transport", "Tips", "Personal insurance"],
    meetingPoint: "Palmeraie quad centre — hotel pickup available",
  },
  {
    id: 5,
    slug: "quad-agafay",
    name: "Quad Biking in Agafay Desert",
    type: "adventure",
    location: "Agafay",
    duration: "2 hours",
    price: 50,
    priceChild: null,
    rating: 4.8,
    reviews: 267,
    minAge: 16,
    fitnessLevel: "Active",
    featured: true,
    emoji: "🏍️",
    bgColor: "#3a2000",
    badge: "Desert Rush",
    description: "Tear across the rocky Agafay desert on a quad bike for an adrenaline-packed adventure with jaw-dropping Atlas Mountain views. The most exciting 2 hours you'll have in Morocco.",
    highlights: [
      "Open desert tracks — no traffic, pure freedom",
      "Atlas Mountains as your backdrop",
      "Experienced guides lead the ride",
      "Sunset session available",
      "Often combined with Agafay day trip",
    ],
    included: ["Quad bike", "Safety gear", "Guide", "Mint tea after ride"],
    excluded: ["Transport to Agafay", "Tips"],
    meetingPoint: "Agafay desert base camp",
  },
  {
    id: 6,
    slug: "buggy-agafay",
    name: "Buggy Ride in Agafay Desert",
    type: "adventure",
    location: "Agafay",
    duration: "2 hours",
    price: 65,
    priceChild: null,
    rating: 4.9,
    reviews: 189,
    minAge: 16,
    fitnessLevel: "Active",
    featured: true,
    emoji: "🚗",
    bgColor: "#2a1500",
    badge: "Best Thrill",
    description: "Drive a powerful off-road buggy through the spectacular Agafay desert landscape. More stable than a quad, the buggy is perfect for couples and those who want more speed and control.",
    highlights: [
      "Powerful 2-seat off-road buggies",
      "Open desert circuit with varied terrain",
      "Perfect for couples and friends",
      "Safety briefing and guided circuit",
      "GoPro footage option available",
    ],
    included: ["Buggy (2 seats)", "Helmets & safety gear", "Guided circuit", "Mint tea"],
    excluded: ["Transport to Agafay", "GoPro rental", "Tips"],
    meetingPoint: "Agafay desert base camp",
  },
  {
    id: 7,
    slug: "horseback-riding-lake-takerkoust",
    name: "Horseback Riding at Lake Takerkoust",
    type: "animal",
    location: "Lake Takerkoust",
    duration: "2 hours",
    price: 45,
    priceChild: 28,
    rating: 4.8,
    reviews: 143,
    minAge: 7,
    fitnessLevel: "All levels",
    featured: false,
    emoji: "🐎",
    bgColor: "#0a2a1a",
    badge: "Scenic",
    description: "Ride along the shores of the beautiful Lake Takerkoust on horseback, with the High Atlas Mountains reflected in the water. A peaceful and scenic experience 40km from Marrakech.",
    highlights: [
      "Ride along a stunning reservoir lakeshore",
      "Atlas Mountain panoramic views",
      "Experienced horses suitable for beginners",
      "Small groups — maximum 8 riders",
      "Berber equestrian guide",
    ],
    included: ["Horse ride", "Helmet", "Guide"],
    excluded: ["Transport to Lake Takerkoust", "Tips"],
    meetingPoint: "Lake Takerkoust stables — transport available",
  },
  {
    id: 8,
    slug: "marrakech-cooking-class",
    name: "Marrakech Cooking Class",
    type: "cultural",
    location: "Marrakech",
    duration: "3.5 hours",
    price: 55,
    priceChild: 30,
    rating: 4.9,
    reviews: 356,
    minAge: 5,
    fitnessLevel: "All levels",
    featured: true,
    emoji: "👨‍🍳",
    bgColor: "#2a0a0a",
    badge: "Top Rated",
    description: "Learn to cook authentic Moroccan cuisine in a beautiful riad kitchen with a passionate local chef. Shop for ingredients in the souks, then cook and eat a 3-course Moroccan feast.",
    highlights: [
      "Morning souk visit to buy fresh ingredients",
      "Cook 3 dishes: salad, tagine, dessert",
      "Traditional riad kitchen setting",
      "Keep the recipe card to cook at home",
      "Mint tea and Moroccan pastries included",
    ],
    included: ["Souk tour", "All ingredients", "Cooking instruction", "3-course meal", "Recipe card", "Mint tea"],
    excluded: ["Transport", "Tips", "Drinks"],
    meetingPoint: "Jemaa el-Fna — specific riad address sent on booking",
  },
  {
    id: 9,
    slug: "pottery-class-marrakech",
    name: "Pottery Class in Marrakech",
    type: "cultural",
    location: "Marrakech",
    duration: "2 hours",
    price: 40,
    priceChild: 22,
    rating: 4.7,
    reviews: 97,
    minAge: 6,
    fitnessLevel: "All levels",
    featured: false,
    emoji: "🏺",
    bgColor: "#2d1500",
    badge: "Artisan",
    description: "Learn the ancient art of Moroccan pottery from a master craftsman in a traditional workshop in the medina. Create your own zellige-inspired piece to take home.",
    highlights: [
      "Hands-on pottery wheel experience",
      "Learn traditional Moroccan patterns",
      "Take your creation home (dried & wrapped)",
      "Master craftsman with 30+ years experience",
      "Small group — maximum 8 people",
    ],
    included: ["All materials", "Master instructor", "Your finished piece to take home", "Mint tea"],
    excluded: ["Transport", "Tips"],
    meetingPoint: "Pottery workshop, Sidi Ghanem district",
  },
  {
    id: 10,
    slug: "sidecar-tour-marrakech",
    name: "Sidecar Tour of Marrakech",
    type: "adventure",
    location: "Marrakech",
    duration: "2 hours",
    price: 50,
    priceChild: 25,
    rating: 4.8,
    reviews: 124,
    minAge: 3,
    fitnessLevel: "All levels",
    featured: false,
    emoji: "🛵",
    bgColor: "#1a1a0a",
    badge: "Unique",
    description: "Explore Marrakech in the most stylish way possible — from the sidecar of a vintage motorcycle. Your local driver takes you through the medina, Palmeraie, and New City in retro style.",
    highlights: [
      "Vintage-style motorcycle and sidecar",
      "Tour the medina, Palmeraie & Gueliz",
      "Fun for couples, families, solo travelers",
      "Commentary from your local driver-guide",
      "Perfect for photography",
    ],
    included: ["Sidecar ride", "Helmet", "Local driver-guide", "Water"],
    excluded: ["Tips", "Extra stops"],
    meetingPoint: "Jemaa el-Fna square",
  },
  {
    id: 11,
    slug: "marrakech-hammam-spa",
    name: "Traditional Hammam & Spa",
    type: "wellness",
    location: "Marrakech",
    duration: "1.5 hours",
    price: 35,
    priceChild: 20,
    rating: 4.8,
    reviews: 289,
    minAge: 5,
    fitnessLevel: "All levels",
    featured: false,
    emoji: "🧖",
    bgColor: "#0a1a2d",
    badge: "Relaxation",
    description: "Experience the ancient Moroccan bathing ritual at a traditional hammam in the medina. Enjoy a steam bath, kessa (exfoliation scrub), and argan oil massage — a total body renewal.",
    highlights: [
      "Traditional hammam steam bath",
      "Kessa exfoliation with kessa glove",
      "Ghassoul clay mask treatment",
      "Argan oil massage",
      "Mint tea and pastries after treatment",
    ],
    included: ["Hammam entry", "Kessa scrub", "Ghassoul mask", "Argan oil massage", "Towel & slippers", "Mint tea"],
    excluded: ["Transport", "Tips", "Optional upgrades"],
    meetingPoint: "Hammam address sent on booking confirmation",
  },
  {
    id: 12,
    slug: "yoga-marrakech",
    name: "Yoga Session in Marrakech",
    type: "wellness",
    location: "Marrakech",
    duration: "1.5 hours",
    price: 25,
    priceChild: null,
    rating: 4.9,
    reviews: 64,
    minAge: null,
    fitnessLevel: "All levels",
    featured: false,
    emoji: "🧘",
    bgColor: "#1a2d1a",
    badge: "Wellness",
    description: "Start your Marrakech morning with a peaceful yoga session on a rooftop terrace overlooking the medina. Suitable for all levels, led by a certified instructor in a serene riad setting — the perfect way to recharge between adventures.",
    highlights: [
      "Rooftop yoga with medina panoramic views",
      "All levels welcome — beginner friendly",
      "Certified bilingual instructor (English/French)",
      "Mats and props provided",
      "Mint tea and snacks included after session",
    ],
    included: ["Yoga mat & props", "Certified instructor", "Mint tea & snacks", "Rooftop access"],
    excluded: ["Transport", "Tips"],
    meetingPoint: "Riad address sent on booking confirmation",
  },
];

export const destinations = [
  {
    id: 1,  
    slug: "marrakech",
    name: "Marrakech",
    region: "Marrakech-Safi",
    tagline: "The Red City",
    emoji: "🕌",
    bgColor: "#5c3d1e",
    image: "https://images.unsplash.com/photo-1670406071577-d795729196b4?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3Dhttps://images.unsplash.com/photo-1597212618440-806262de4f3b?w=800&q=80",
    tourCount: 8,
    activityCount: 9,
    bestTime: "March–May, September–November",
    climate: "Semi-arid, hot summers, mild winters",
    distanceFromMarrakech: "—",
    description: "Marrakech is Morocco's most vibrant city — a dizzying blend of ancient medina, luxury riads, world-class restaurants, and the legendary Jemaa el-Fna square. The beating heart of Moroccan tourism.",
    highlights: ["Jemaa el-Fna square", "Koutoubia Mosque", "Majorelle Garden", "Ben Youssef Madrasa", "Souks", "Bahia Palace"],
  },
  {
    id: 2,
    slug: "atlas-mountains",
    name: "Atlas Mountains",
    region: "Marrakech-Safi / Drâa-Tafilalet",
    tagline: "Roof of North Africa",
    emoji: "⛰️",
    bgColor: "#2a4020",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80",
    tourCount: 3,
    activityCount: 2,
    bestTime: "April–June, September–October",
    climate: "Cool mountain climate, snow in winter",
    distanceFromMarrakech: "60–80 km / 1.5–2 hours",
    description: "The High Atlas Mountains rise dramatically south of Marrakech, home to Berber villages, trekking trails, and Jbel Toubkal — North Africa's highest peak at 4,167m.",
    highlights: ["Imlil valley", "Jbel Toubkal", "Berber villages", "Asni market", "Tizi n'Tichka pass", "Cascades d'Imlil"],
  },
  {
    id: 3,
    slug: "agafay-desert",
    name: "Agafay Desert",
    region: "Marrakech-Safi",
    tagline: "The Stone Desert",
    emoji: "🏜️",
    bgColor: "#4a3010",
    image: "https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=800&q=80",
    tourCount: 1,
    activityCount: 5,
    bestTime: "October–April",
    climate: "Hot and dry, cooler evenings",
    distanceFromMarrakech: "40 km / 45 minutes",
    description: "The Agafay Desert is a unique rocky plateau just 40 minutes from Marrakech — a dramatic lunar landscape of ochre stone, Berber camps, and Atlas Mountain views perfect for adventure activities.",
    highlights: ["Rocky desert plateau", "Berber camps", "Atlas Mountain views", "Quad biking", "Camel rides", "Sunset panoramas"],
  },
  {
    id: 4,
    slug: "essaouira",
    name: "Essaouira",
    region: "Marrakech-Safi (Coast)",
    tagline: "The Windy City",
    emoji: "🌊",
    bgColor: "#1a3050",
    image: "https://images.unsplash.com/photo-1624802704371-c76faa34c3a0?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tourCount: 1,
    activityCount: 0,
    bestTime: "April–October",
    climate: "Atlantic coastal, windy and mild year-round",
    distanceFromMarrakech: "165 km / 2.5 hours",
    description: "Essaouira is Morocco's most charming coastal town — a walled blue-and-white medina on the Atlantic with Portuguese ramparts, Gnawa music, fresh seafood, and world-class windsurfing.",
    highlights: ["UNESCO medina", "Portuguese ramparts", "Harbour and fish market", "Atlantic beach", "Gnawa music", "Argan oil cooperatives"],
  },
  {
    id: 5,
    slug: "ouzoud",
    name: "Ouzoud Waterfalls",
    region: "Béni Mellal-Khénifra",
    tagline: "Morocco's Greatest Waterfall",
    emoji: "💧",
    bgColor: "#0a3020",
    image: "https://www.image2url.com/r2/default/images/1776889330860-491f6402-d23c-4714-80b8-2b5485c43d64.jpg",
    tourCount: 1,
    activityCount: 0,
    bestTime: "March–June",
    climate: "Mediterranean, pleasant year-round",
    distanceFromMarrakech: "155 km / 2.5 hours",
    description: "The Ouzoud Waterfalls are Morocco's most spectacular natural sight — a 110-metre cascade plunging into emerald pools surrounded by olive trees, wild macaques, and rainbow mist.",
    highlights: ["110m waterfall cascade", "Natural swimming pools", "Wild Barbary macaques", "Rainbow mist", "Boat rides under the falls", "Olive grove walks"],
  },
  {
    id: 6,
    slug: "ait-ben-haddou",
    name: "Aït Ben Haddou",
    region: "Drâa-Tafilalet",
    tagline: "UNESCO Kasbah",
    emoji: "🏰",
    bgColor: "#4a2010",
    image: "https://images.unsplash.com/photo-1737927427538-9f9b4ea4ab02?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tourCount: 1,
    activityCount: 0,
    bestTime: "March–May, September–November",
    climate: "Hot and dry, cool winters",
    distanceFromMarrakech: "190 km / 3 hours",
    description: "Aït Ben Haddou is one of Morocco's most iconic sights — a towering pre-Saharan ksar of mud-brick towers perched above the Ounila River. A UNESCO World Heritage Site and filming location of Game of Thrones.",
    highlights: ["UNESCO World Heritage Site", "Game of Thrones filming location", "Ancient mud-brick towers", "Kasbah Telouet nearby", "Tizi n'Tichka mountain pass", "Traditional crafts"],
  },
  {
    id: 7,
    slug: "ourika-valley",
    name: "Ourika Valley",
    region: "Marrakech-Safi",
    tagline: "The Green Valley",
    emoji: "🌿",
    bgColor: "#1a3020",
    image: "https://images.unsplash.com/photo-1671804079626-4aaafa95184e?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tourCount: 1,
    activityCount: 0,
    bestTime: "March–June, September–October",
    climate: "Cooler than Marrakech, fresh mountain air",
    distanceFromMarrakech: "30 km / 45 minutes",
    description: "The Ourika Valley is one of the closest escapes from Marrakech — a lush river valley of Berber villages, terraced gardens, and waterfalls tucked into the Atlas foothills.",
    highlights: ["Setti Fatma waterfalls", "Berber villages", "Argan oil cooperatives", "Herbalist gardens", "River walks", "Weekly market"],
  },
  {
    id: 8,
    slug: "casablanca",
    name: "Casablanca",
    region: "Casablanca-Settat",
    tagline: "Morocco's Metropolis",
    emoji: "🏙️",
    bgColor: "#1a1a3d",
    image: "https://images.unsplash.com/photo-1701945247920-7e4a461e08cb?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    tourCount: 1,
    activityCount: 0,
    bestTime: "Year-round",
    climate: "Mediterranean coastal, mild and pleasant",
    distanceFromMarrakech: "240 km / 3.5 hours",
    description: "Casablanca is Morocco's economic powerhouse and largest city — a fascinating blend of art deco French colonial architecture, the world's third-largest mosque, and a buzzing Atlantic Corniche.",
    highlights: ["Hassan II Mosque", "Art deco quarter", "Corniche promenade", "Morocco Mall", "Old Medina", "Rick's Café"],
  },
];

export const blogPosts = [
  {
    id: 1,
    slug: "best-time-to-visit-morocco",
    title: "Best Time to Visit Morocco in 2025",
    category: "travel-tips",
    categoryLabel: "Travel Tips",
    readTime: "5 min",
    excerpt: "Morocco is a year-round destination, but the best time to visit depends on where you're going and what you want to do. Here's our complete seasonal guide.",
    emoji: "🌤️",
    bgColor: "#2a3d20",
    date: "December 2024",
  },
  {
    id: 2,
    slug: "agafay-desert-complete-guide",
    title: "Agafay Desert: Everything You Need to Know",
    category: "desert-tours",
    categoryLabel: "Desert Tours",
    readTime: "7 min",
    excerpt: "The Agafay Desert is one of Morocco's best-kept secrets. Just 40 minutes from Marrakech, this rocky plateau offers a stunning desert experience without the long drive to the Sahara.",
    emoji: "🏜️",
    bgColor: "#3d2010",
    date: "November 2024",
  },
  {
    id: 3,
    slug: "marrakech-medina-guide-first-timers",
    title: "Marrakech Medina: Complete Guide for First-Timers",
    category: "city-guides",
    categoryLabel: "City Guides",
    readTime: "8 min",
    excerpt: "The Marrakech medina can feel overwhelming on your first visit. Our local expert guide breaks down everything you need to know: where to go, what to see, and how not to get lost.",
    emoji: "🕌",
    bgColor: "#1a2540",
    date: "October 2024",
  },
  {
    id: 4,
    slug: "what-to-pack-for-morocco",
    title: "What to Pack for Morocco: The Complete Packing List",
    category: "travel-tips",
    categoryLabel: "Travel Tips",
    readTime: "6 min",
    excerpt: "Packing for Morocco requires some thought — the climate varies dramatically, dress codes matter in medinas, and desert trips need specific gear. Here's exactly what to bring.",
    emoji: "🎒",
    bgColor: "#2d1a0a",
    date: "September 2024",
  },
  {
    id: 5,
    slug: "moroccan-food-guide",
    title: "Moroccan Food: A Complete Guide to Eating in Morocco",
    category: "food-guides",
    categoryLabel: "Food Guides",
    readTime: "9 min",
    excerpt: "From tagine to pastilla, harira to msemen — Moroccan cuisine is one of the world's great food traditions. Here's everything you need to know before you eat your way through Morocco.",
    emoji: "🥘",
    bgColor: "#3d1a0a",
    date: "August 2024",
  },
  {
    id: 6,
    slug: "morocco-7-day-itinerary",
    title: "The Perfect 7-Day Morocco Itinerary from Marrakech",
    category: "morocco-guides",
    categoryLabel: "Morocco Guides",
    readTime: "10 min",
    excerpt: "One week in Morocco — how do you fit in Marrakech, the desert, the mountains, and the coast? Our expert-crafted 7-day itinerary covers the best of Morocco with zero wasted days.",
    emoji: "🗺️",
    bgColor: "#1a1a3d",
    date: "July 2024",
  },
];

export const testimonials = [
  { id: 1, name: "Sarah M.", country: "United Kingdom", flag: "🇬🇧", rating: 5, text: "The Atlas Mountains trip was absolutely breathtaking. Our guide Ahmed was knowledgeable, funny, and made the whole day unforgettable. Already planning my return trip!", tour: "Atlas Mountains Day Trip" },
  { id: 2, name: "Pierre D.", country: "France", flag: "🇫🇷", rating: 5, text: "The hot air balloon at sunrise over Marrakech was a once-in-a-lifetime experience. Worth every euro — I cannot recommend this highly enough to anyone visiting Morocco.", tour: "Hot Air Balloon Ride" },
  { id: 3, name: "Jessica T.", country: "United States", flag: "🇺🇸", rating: 5, text: "The cooking class was so much fun. We visited the souk in the morning, learned real Moroccan recipes, and ate the most amazing tagine I've ever tasted. Highly recommend!", tour: "Marrakech Cooking Class" },
  { id: 4, name: "Marco R.", country: "Italy", flag: "🇮🇹", rating: 5, text: "Agafay desert day trip with quad biking — absolutely incredible. The landscape looked like another planet. Our guide was fantastic and made sure we had the best time.", tour: "Agafay Desert Day Trip" },
  { id: 5, name: "Emma L.", country: "Australia", flag: "🇦🇺", rating: 5, text: "I was nervous about the medina tour but our guide made it so easy. We saw things I never would have found alone. The food tour afterwards was the highlight of my whole trip!", tour: "Marrakech Medina Tour" },
  { id: 6, name: "Lars K.", country: "Germany", flag: "🇩🇪", rating: 5, text: "Ouzoud Waterfalls — the monkeys alone were worth the trip! But the waterfall itself is something else entirely. Beautiful day, professional organisation, excellent guide.", tour: "Ouzoud Waterfalls Day Trip" },
];

export const faqs = [
  {
    category: "Booking & Payment",
    questions: [
      { q: "How do I book a tour or activity?", a: "You can book directly on our website using the booking form on each tour page. Select your date, number of travelers, and pay securely by card or PayPal. You can also book via WhatsApp — just send us a message and we'll confirm your booking within minutes." },
      { q: "Do I need to pay the full amount in advance?", a: "You can choose to pay a 20% deposit to secure your booking, with the balance due on the day of the tour. Full payment online is also accepted and comes with an extra 5% discount." },
      { q: "What payment methods do you accept?", a: "We accept Visa, Mastercard, American Express, PayPal, Apple Pay, and Google Pay via our secure Stripe checkout. We also accept bank transfers for group bookings." },
      { q: "Can I book via WhatsApp?", a: "Absolutely! Many of our guests prefer WhatsApp. Just message us at +212 600 000 000 with your chosen tour, date, and group size and we'll confirm your booking instantly." },
    ],
  },
  {
    category: "Tours & Activities",
    questions: [
      { q: "Are hotel pickups included?", a: "Yes, hotel pickup and drop-off is included in all our day trips and most activities. Just provide your hotel name and address when booking and we'll collect you directly from your accommodation." },
      { q: "What languages are tours available in?", a: "Our tours are available in English, French, and Arabic. Spanish is also available on request for select tours. Please specify your preferred language when booking." },
      { q: "Are tours available for private groups?", a: "Yes! All of our tours can be arranged as private experiences for your group. Private tours are great for families, couples, or corporate groups who prefer a personalised itinerary." },
      { q: "What is the maximum group size?", a: "Group sizes vary by tour — typically 8–15 people for standard tours. Private tours have no maximum. Check each tour page for specific group size limits." },
    ],
  },
  {
    category: "Cancellation & Changes",
    questions: [
      { q: "What is your cancellation policy?", a: "We offer free cancellation up to 48 hours before your tour for day trips, and up to 24 hours before for city tours and activities. Cancellations within 24 hours may incur a 50% charge." },
      { q: "Can I change my booking date?", a: "Yes, you can change your tour date free of charge up to 48 hours before the original date, subject to availability. Contact us via WhatsApp or email and we'll sort it out quickly." },
    ],
  },
  {
    category: "What to Bring",
    questions: [
      { q: "What should I wear on a tour?", a: "Comfortable walking shoes are essential. For the medina, modest clothing is recommended (shoulders and knees covered). For desert and mountain trips, bring layers as temperatures can vary significantly." },
      { q: "Do I need to bring water?", a: "Bottled water is included on all our day trips. For city tours, we recommend bringing your own bottle as Morocco can be hot. Stay well hydrated!" },
    ],
  },
];
